// eslint-disable-next-line import/no-self-import
import memoize from 'memoize-one';

import { isEqualObject, isEqualArray } from 'common/utils/data-utils';

export const memoizeObject = fn => memoize(fn, isEqualObject);

export const memoizeArray = fn => memoize(fn, isEqualArray);

export default {};
